"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAlertOverrides = function (_a) {
    var _b, _c;
    var spacing = _a.spacing, breakpoints = _a.breakpoints;
    return ({
        root: (_b = {
                padding: spacing(1, 4)
            },
            _b[breakpoints.up("xl")] = {
                padding: spacing(2, 4),
            },
            _b),
        filledSuccess: {
            fontWeight: undefined,
        },
        filledError: {
            fontWeight: undefined,
        },
        icon: {
            marginRight: spacing(3),
        },
        action: {
            marginRight: undefined,
            paddingLeft: spacing(3),
        },
        message: (_c = {
                padding: spacing(2, 0)
            },
            _c[breakpoints.up("xl")] = {
                padding: 0,
            },
            _c),
    });
};
//# sourceMappingURL=MuiAlert.js.map